import OrderIcon from "@mui/icons-material/AttachMoney"

import OrderEdit from "./OrderEdit"
import OrderList from "./OrderList"
import OrderTravelSheet from "./OrderTravelSheet"

export default {
  list: OrderList,
  edit: OrderEdit,
  show: OrderTravelSheet,
  icon: OrderIcon,
}
